<template>
  <CollectionContainer>
    <div class="collection-products">
      <div class="collection-products__inner" v-if="products.length > 0">
        <div class="collection__introduction">
          <div class="collection__subtitle">
            <span>Search</span>
            <span>Results: <span v-html="count"></span></span>
          </div>
          <CollectionSearchTitle class="collection__title" :terms="terms" />
        </div>
        <ProductCard v-for="product in products" :key="product.id" :product="product"></ProductCard>
      </div>
      <div class="collection-products__empty" v-else>Searching "{{ terms }}"...</div>
    </div>
  </CollectionContainer>
</template>

<script lang="ts" setup>
import { Ref, onMounted, ref } from 'vue'
import CollectionSearchTitle from '../collection/CollectionSearchTitle.vue'
import ProductCard from '../product/card/ProductCard.vue'
import { fetchSearchWithAllProducts } from '_library'
import { ProductFieldsFragment } from '_library/src/storefront/generated'
import CollectionContainer from '../collection/CollectionContainer.vue'

const props = defineProps<{
  terms: string
  count: number
}>()

const products: Ref<ProductFieldsFragment[]> = ref([])
const isDraft = (product: ProductFieldsFragment) => product.tags.find((tag) => tag == 'draft')
const isPreview = !!new URLSearchParams(window.location.search).get('preview')

onMounted(async () => {
  await fetchSearchWithAllProducts(props.terms, (results: ProductFieldsFragment[]) => {
    products.value = results.filter(
      (product) =>
        product.productType !== 'Admin' && (!isDraft(product) || (isDraft(product) && isPreview))
    )
  })
})
</script>

<style lang="scss">
@import '~styles/base';

.collection {
  &__introduction {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 15px;
    border: 1px solid;
    opacity: 1;
    flex-shrink: 0;

    @include breakpoint('l') {
      grid-column: span 2;
      height: 450px;
      margin-top: 40px;

      &_hide_mobile {
        display: none;
      }
    }
  }

  &__subtitle {
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    font-size: var(--font-xs);
    line-height: var(--font-lh-xs);
    letter-spacing: 0.03em;
  }

  &__title {
    margin: auto 0;
    font-size: 42px;
    text-align: center;
    text-transform: uppercase;
    @include type-xxl;
  }
}
</style>
